module.exports = __webpack_public_path__ + "static/img/banner_2x.14682ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/banner_2x.png
// module id = kBgr
// module chunks = 1